@if (isCreateMode) {
  <div class="note-card note-card--editable">
    <div class="note-header">Note to Approver</div>
    <textarea
      id="txt-note-to-approver"
      data-id="txt-note-to-approver"
      class="note-textarea"
      [maxlength]="250"
      placeholder="Add a note here to provide additional information to the approver."
      [ngModel]="noteText"
      (ngModelChange)="onNoteChange($event)"
    ></textarea>
    <div class="note-card-fold"></div>
  </div>
} @else if (noteText) {
  <div class="note-card note-card--readonly">
    <div class="note-header">Note to Approver</div>
    <div class="note-text">{{ noteText }}</div>
  </div>
}
